import { api } from "@shared/lib/api";
import { BackednResponse } from "@shared/lib/types";
import { GetCampaignReachoutInfluencers } from "@shared/lib/types/campaignReachoutInfluencer";

export class CampaignReachoutService {
  public static async campaignReachOut(data: {
    brandName: string;
    briefName: string;
    deliverables: string;
    timeline: string;
    socialMedias: {
      username: string;
      emailId: string;
      platform: string;
      isUserEntered: boolean;
    }[];
  }) {
    return (await api
      .post(`influencer/campaing-reach-out`, {
        json: data,
      })
      .json()) as BackednResponse<{}>;
  }

  public static async getCampaignReachoutsInfluencer({
    limit,
    pageNo,
  }: {
    limit: Number;
    pageNo: Number;
  }) {
    const params = new URLSearchParams();

    if (limit) {
      params.append("limit", limit.toString());
    }
    if (pageNo) {
      params.append("pageNo", pageNo.toString());
    }

    // Convert params to string and add to URL only if there are parameters
    const queryString = params.toString();

    const url = `influencer/campaing-reach-out/search${
      queryString ? `?${queryString}` : ""
    }`;
    return (await api
      .get(url)
      .json()) as BackednResponse<GetCampaignReachoutInfluencers>;
  }
}
